import EPubUploadModel from '../EPubForm/model/EPubUploadModel';

const EPubUploadStore = {
    name: 'EPubUploadStore',
    spec: EPubUploadModel,
    saveLocally: false,
    initialState:{
      res:"Oops...Something went wrong. Please try again."
    }
  }

const stores=[EPubUploadStore]

export default stores;